import { useTranslations } from "use-intl";
import ForgotPasswordForm from "@/components/forgot-password-form";
import { Logo } from "@/components/logo";
function ForgotPasswordRoute() {
  // Mirrors the source server component — uses globals.auth from the full tree.
  const t = useTranslations("globals.auth");
  return <div className="flex min-h-[calc(100vh-57px)]">
      <div className="hidden lg:flex lg:w-1/2 bg-primary/5 relative overflow-hidden items-center justify-center">
        <div className="vinyl-texture absolute inset-0" />
        <div className="relative z-10 flex flex-col items-center gap-6 px-12 text-center">
          <Logo className="size-20 text-primary" />
          <p className="text-4xl font-bold tracking-tight">Garimpa.Club</p>
          <p className="text-lg text-muted-foreground max-w-sm">{t("loginTagline")}</p>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="flex flex-col items-center gap-3 mb-8 lg:hidden">
            <Logo className="size-12 text-primary" />
            <h2 className="text-xl font-bold tracking-tight">Garimpa.Club</h2>
          </div>

          <ForgotPasswordForm />
        </div>
      </div>
    </div>;
}
export { ForgotPasswordRoute as component };